<template>
    <li :class="['nav-item', { active: isActive }]" @click="hideSidebar">
        <router-link
            :to="to"
            class="nav-link"
            v-bind="$attrs"
            @click="handleClick"
        >
            <slot>
                <i v-if="icon" :class="icon"></i>
                <p>{{ name }}</p>
            </slot>
        </router-link>
    </li>
</template>

<script>
import { mapActions } from 'vuex';
import { isMenuRouteActive } from '@/utils/menuRoute';

export default {
    name: 'SidebarLinkComponent',
    inheritAttrs: false,
    props: {
        name: String,
        icon: String,
        to: {
            type: String,
            required: true,
        },
    },
    inject: {
        autoClose: {
            default: true,
        },
        addLink: {
            default: () => {},
        },
    },
    computed: {
        isActive() {
            return isMenuRouteActive(this.$route.fullPath, this.to);
        },
    },
    methods: {
        ...mapActions('sidebar', ['setSidebar']),
        hideSidebar() {
            if (!this.autoClose) return;
            if (
                typeof window !== 'undefined' &&
                window.matchMedia('(max-width: 991px)').matches
            ) {
                this.setSidebar(false);
            }
        },
        handleClick(event) {
            const href = event.currentTarget.getAttribute('href');
            // 清掉列表捲動記錄
            localStorage.removeItem('tableScrollLeft');
            // 若點到完全相同的網址（包含 query），強制重新整理
            const current = window.location.pathname + window.location.search;
            if (href === current) {
                window.location.assign(href);
            }
        },
    },
    mounted() {
        if (this.addLink) {
            this.addLink(this);
        }
    },
    beforeUnmount() {
        if (this.removeLink) {
            this.removeLink(this);
        }
    },
};
</script>

<style scoped></style>
